import { noop } from 'lodash';
import { isProductionEnv } from '@flow/env';
import type { ClientLogLevel } from './types';

type LoggerFunction = (...args: any[]) => void;

/**
 * Creates a logger function that conditionally logs messages based on the environment.
 * In a production environment, the logger function is a no-op and does nothing.
 * In other environments, the provided logging function is used.
 *
 * @param logFn - The logging function to be used in non-production environments.
 * @returns A logger function that either logs messages or performs no operation.
 */
const createLogger = (logFn: LoggerFunction): LoggerFunction => {
  if (isProductionEnv()) {
    return noop; // No-op in production
  }
  return logFn;
};

export const clientLogger: Record<ClientLogLevel, LoggerFunction> = {
  log: createLogger(console.log.bind(console)),
  debug: createLogger(console.debug.bind(console)),
  info: createLogger(console.info.bind(console)),
  warn: createLogger(console.warn.bind(console)),
  error: createLogger(console.error.bind(console)),
};
